import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from '../services/schedule.service';
import { Schedule } from '../models/schedule';

@Component({
    selector: 'confirmation',
    templateUrl: './confirmation.html',
    styleUrls: ['./confirmation.component.css'],
    providers: [ScheduleService]
})
export class ConfirmationComponent {
    public schedule: Schedule;
    constructor(
        private _route: ActivatedRoute,
        private _router: Router,
        private _scheduleService: ScheduleService
    ) {
        this.schedule = new Schedule();
    }
    ngOnInit() {
        const scheduleId = JSON.parse(localStorage.getItem('schedule'));
        console.log(scheduleId);
        
        if(scheduleId != undefined) {
            this.getScheduleById(scheduleId.id);
        }        
    }
    getScheduleById(id) {
        this._scheduleService.getById(id).subscribe(
            response => {
                if(response.statusCode === '200 OK') {
                    this.schedule = response.object;
                } else {
                    console.log(response);
                    alert('No Encontrado');
                }
            },
            error => {
                console.log(<any>error);
                alert('Error al Consultar');
            }
        );
    }
}